<div class="flex-direction-column justify-between container-card-sessao">
  <div>
    <app-card-sessao-linha-superior
      [nomeContato]="sessao?.contato?.nome"
      [numeroContato]="sessao?.contato?.numero"
      [isAtivo]="sessao?.ativo"
      [isExibicao]="isExibicao"
      (exibirDetalhes)="abrirModalDetalhes()"
      (modalChat)="abrirModalChat()"
      (editarDetalhes)="abrirModalEdicaoDetalhes()"
      (reiniciarSessao)="abrirModalReiniciarSessao()"
    >
    </app-card-sessao-linha-superior>
  </div>
  <div class="flex-direction-column gap-5">
    <span class="font-mobile color-primary">Etapa do Fluxo</span>
    <span class="font-mobile">{{ sessao?.fluxo?.nome || '-' }} | {{ sessao?.etapa?.titulo || '—' }}</span>
  </div>
  <div>
    <app-card-sessao-linha-central
      [sessao]="sessao"
    >
    </app-card-sessao-linha-central>
  </div>
  <div>
    <app-card-sessao-linha-canal
      [sessao]="sessao"
    >
    </app-card-sessao-linha-canal>
  </div>
  <div>
    <app-card-sessao-linha-inferior
      [sessao]="sessao"
    >
    </app-card-sessao-linha-inferior>
  </div>
</div>
